import React, { useState, useEffect } from "react";
import { fetchUserData } from "../Utils/api";

const Location = ({ userName }) => {
  const [data, setdata] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getData = async () => {
      try {
        const result = await fetchUserData(userName);
        setdata(result[0]);
      } catch (error) {
        console.log("error fetching data in location", error);
      } finally {
        setLoading(false);
      }
    };
    getData();
  }, [userName]);
  const googleMapUrl = `https://www.google.com/maps?q=${encodeURIComponent(
    data.address
  )}&output=embed`;

  if (loading)
    return <p style={{ textAlign: "center", padding: "10px" }}>Loading...</p>;
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "10px",
        paddingBottom: "20px",
      }}
    >
      <iframe
        title="Google Maps Location"
        // src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d666824.7357863735!2d50.588702!3d26.240045!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e49a500714c1523%3A0x6fddb901ade3bbdb!2sDHANAM%20TECHNOLOGIES%20W.L.L!5e1!3m2!1sen!2sin!4v1739440273297!5m2!1sen!2sin"
        src={googleMapUrl}
        width="100%"
        height="250px"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
        style={{ border: "none" }}
      ></iframe>
    </div>
  );
};

export default Location;
